import { render, staticRenderFns } from "./HeaderTemplate.vue?vue&type=template&id=68b7b5f8&scoped=true"
import script from "./HeaderTemplate.vue?vue&type=script&lang=js"
export * from "./HeaderTemplate.vue?vue&type=script&lang=js"
import style0 from "./HeaderTemplate.vue?vue&type=style&index=0&id=68b7b5f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b7b5f8",
  null
  
)

export default component.exports